export const breakpoint = {
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1440px)',
  xxl: '(min-width: 1681px)',
}